import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";
import ShortLinkRedirectPage from "./ShortLinkRedirectPage";

export type CommonPagesNavigationParams = {
  commonShortLinkRedirect: PageNavParams<{ shortLinkId: string }>;
};

export const commonPagesNavigationConfig: ModulePagesConfig<CommonPagesNavigationParams> =
  {
    commonShortLinkRedirect: {
      element: <ShortLinkRedirectPage />,
      path: "/L/:shortLinkId",
      isPrivate: true,
      isEntityOptional: true,
    },
  };
